import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import App from './App.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { applyTheme, getPreferredTheme } from './utils/theme';

try {
  const savedLocale = localStorage.getItem("zedi_locale");
  const supported = ["en","fr","de","es","it","pt","el","zh","ja","ko","bn","ar","yi"];
  const langs = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language || "en"];
  let initial = savedLocale || "en";
  if (!savedLocale) {
    for (const tag of langs) {
      const lower = String(tag || "").toLowerCase();
      const base = lower.split("-")[0];
      if (supported.includes(lower)) { initial = lower; break; }
      if (supported.includes(base)) { initial = base; break; }
    }
  }
  document.documentElement.setAttribute("lang", initial);
  document.documentElement.setAttribute("dir", ["ar","yi"].includes(initial) ? "rtl" : "ltr");
} catch {}

try {
  applyTheme(getPreferredTheme());
} catch {}

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error("❌ Error: Root element 'root' not found in index.html");
  const fallback = document.createElement('div');
  fallback.style.fontFamily = 'system-ui, sans-serif';
  fallback.style.padding = '1rem';
  fallback.style.color = '#b91c1c';
  fallback.textContent = 'The application failed to load because the root element was not found.';
  document.body.appendChild(fallback);
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);

    const appTree = (
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );

    root.render(
      process.env.NODE_ENV === "development" ? appTree : <React.StrictMode>{appTree}</React.StrictMode>
    );
  } catch (error) {
    console.error("❌ Critical Error: Failed to render React app.", error);
    const fallback = document.createElement('div');
    fallback.style.fontFamily = 'system-ui, sans-serif';
    fallback.style.padding = '1rem';
    fallback.style.color = '#b91c1c';
    fallback.textContent = 'The application failed to render. Check the console for details.';
    document.body.appendChild(fallback);
  }
}

// Disable service worker to stop reload loops; re‑enable when needed.
serviceWorkerRegistration.unregister();

// 📊 Report performance metrics (optional)
reportWebVitals();
